import { Calendar, Mail, MapPin, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useConfig } from '../hooks/useConfig';

const Footer = () => {
  const { site } = useConfig();

  const footerSections = [
    {
      title: 'Product',
      links: [
        { name: 'How It Works', href: '/demo' },
        { name: 'Pricing', href: '/pricing' },
        { name: 'Demo', href: '/demo' },
        { name: 'Features', href: '/demo/features' }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', href: '/about' },
        { name: 'Our Mission', href: '/about/mission' },
        { name: 'Our Team', href: '/about/team' },
        { name: 'Our Values', href: '/about/values' }
      ]
    },
    {
      title: 'Support',
      links: [
        { name: 'Help Center', href: '/support' },
        { name: 'Contact Us', href: '/support/contact' },
        { name: 'Setup Guide', href: '/support' },
        { name: 'FAQ', href: '/support' }
      ]
    },
    {
      title: 'Legal',
      links: [
        { name: 'Privacy Policy', href: '/legal' },
        { name: 'Terms of Service', href: '/legal' },
        { name: 'Data Security', href: '/legal' },
        { name: 'Compliance', href: '/legal' }
      ]
    }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="md:col-span-1">
            <div className="flex items-center mb-4">
              <Calendar className="h-8 w-8 text-blue-400" />
              <span className="ml-2 text-xl font-bold">{site.company.name}</span>
            </div>
            <p className="text-gray-400 mb-4">
              {site.company.description}
            </p>
            <div className="space-y-2 text-gray-400 text-sm">
              <div className="flex items-center">
                <Mail className="h-4 w-4 mr-2" />
                <a href={`mailto:${site.contact.supportEmail}`} className="hover:text-white">
                  {site.contact.supportEmail}
                </a>
              </div>
              <div className="flex items-center">
                <Phone className="h-4 w-4 mr-2" />
                <a href={`tel:${site.contact.supportPhone}`} className="hover:text-white">
                  {site.contact.supportPhone}
                </a>
              </div>
              {site.company.address && (
                <div className="flex items-start">
                  <MapPin className="h-4 w-4 mr-2 mt-0.5" />
                  <span>{site.company.address}</span>
                </div>
              )}
            </div>
          </div>

          {/* Navigation Sections */}
          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="font-medium mb-4">{section.title}</h3>
              <ul className="space-y-2 text-gray-400">
                {section.links.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="hover:text-white transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              &copy; {site.legal.foundedYear} {site.company.name}. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0 flex space-x-6">
              <Link to="/legal" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy
              </Link>
              <Link to="/legal" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms
              </Link>
              <Link to="/support" className="text-gray-400 hover:text-white text-sm transition-colors">
                Support
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;